export type InputSize = 'medium' | 'large' | 'small'
export const inputSizesValues: Record<InputSize, number> = {
  small: 26,
  medium: 34,
  large: 40,
}
